import common from '@/services/common'
import Vue from 'vue'

export default {
  async platforms() {
    console.log("apiconfig - platforms()")
    return common.execute("GET", "/api/appconfig/v1/platforms")
      .then(result => result.platforms)
  },
  async configs(platformID) {
    console.log("apiconfig - configs(", platformID, ")")
    return common.execute("GET", `/api/appconfig/v1/platforms/${platformID}/configs`)
      .then(result => {
        // reverse the major and minors versions to be in descending order
        return result.configs.reverse().map(c => {
          if (c.minors && c.minors.length) {
            c.minors.reverse()
          }
          return c
        })
      })
  },
  async files(platformID, majorConfigID, minorConfigID) {
    console.log("apiconfig - files(", platformID, majorConfigID, minorConfigID, ")")
    const minorQueryParam = minorConfigID ? `?minorID=${minorConfigID}` : ""
    return common.execute("GET", `/api/appconfig/v1/platforms/${platformID}/configs/${majorConfigID}/files${minorQueryParam}`)
      .then(result => result.files)
  },
  async createMajor(platformID, majorConfigVersion) {
    console.log("apiconfifg - createMajor(", platformID, majorConfigVersion, ")")
    const body = {
      version: majorConfigVersion.toString(),
    }
    return common.execute("POST", `/api/appconfig/v1/platforms/${platformID}/configs`, body).then(result => {
      Vue.prototype.$alert.success(`Config Major Version [${majorConfigVersion}] created successfully`)
      return result.id
    })
  },
  async cloneMajor(platformID, cloneMajorVersion, majorConfigVersion) {
    return Promise.resolve(true).then(() => {
      Vue.prototype.$alert.success(`Config Major Version [${majorConfigVersion}] cloned from [${cloneMajorVersion}] successfully`)
    })
  },
  async createMinor(platformID, majorID, minorConfigVersion) {
    console.log("apiconfifg - createMinor(", platformID, majorID, minorConfigVersion, ")")
    const body = {
      version: minorConfigVersion.toString(),
    }
    return common.execute("POST", `/api/appconfig/v1/configs/${majorID}/minor`, body).then(result => {
      Vue.prototype.$alert.success(`Config Minor Version [${minorConfigVersion}] created successfully`)
      return result.id
    })
  },
  async cloneMinor(platformID, majorID, cloneMinorVersion, minorConfigVersion) {
    return Promise.resolve(true).then(() => {
      Vue.prototype.$alert.success(`Config Minor Version [${minorConfigVersion}] cloned from [${cloneMinorVersion}] successfully`)
    })
  },
  async createFile(majorID, fileName) {
    return Promise.resolve(true).then(() => {
      Vue.prototype.$alert.success(`Config File [${fileName}] created successfully`)
    })
  },
}